import { render, staticRenderFns } from "./RoleUserList.vue?vue&type=template&id=5cb63a4c&scoped=true"
import script from "./RoleUserList.vue?vue&type=script&lang=js"
export * from "./RoleUserList.vue?vue&type=script&lang=js"
import style0 from "./RoleUserList.vue?vue&type=style&index=0&id=5cb63a4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb63a4c",
  null
  
)

export default component.exports